import { Repository } from "./Repository";
import { AxiosRequestConfig } from "axios";

export class ChangesRepository extends Repository {
  async get(restAuth: AxiosRequestConfig | undefined): Promise<string[]> {
    const data = await this.api.get(restAuth, "/sep_edit/v1/changes");
    if (data) {
        return data;
    }

    return [];
  }

  async publish(restAuth: AxiosRequestConfig | undefined) {
    const data = await this.api.update(restAuth, "/sep_edit/v1/changes/confirm", {});
    if (data) {
        return true;
    }
    return false;
  }

  async discard(restAuth: AxiosRequestConfig | undefined) {
    const data = await this.api.update(restAuth, "/sep_edit/v1/changes/revert", {});
    if (data) {
        return true;
    }
    return false;
  }
}